import React from "react";
import "./SectorsSection.css";

const FrontOfficeTrustSection = () => {
  const sectors = [
    "Corporate Offices",
    "IT Companies",
    "Financial Institutions",
    "Healthcare Facilities",
    "Educational Institutions",
    "Hotels & Hospitality",
    "Co-working Spaces",
    "Manufacturing Facilities",
    "Retail Headquarters",
    "Government Offices",
    "Professional Services Firms",
    "Commercial Buildings"
  ];

  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FrontOfficeTrustSection;
